import { render, staticRenderFns } from "./Orderpro.vue?vue&type=template&id=1fdcd0a4&scoped=true&"
import script from "./Orderpro.vue?vue&type=script&lang=js&"
export * from "./Orderpro.vue?vue&type=script&lang=js&"
import style0 from "./Orderpro.vue?vue&type=style&index=0&id=1fdcd0a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdcd0a4",
  null
  
)

export default component.exports